// extracted by mini-css-extract-plugin
export default {"buttonSize":"RequestErrorModal_buttonSize__z1odL","textSize":"RequestErrorModal_textSize__JIfP+"};